module.exports = __webpack_public_path__ + "img/yw-three.b4c13a6f.png";